module.exports = __webpack_public_path__ + "img/parter-work11.1016015a.png";